import { Box, SxProps } from '@mui/material';
import { OrganizationLogo } from './OrganizationLogo';
import { useOrganizationConfig } from 'core/stores/hooks/useOrganizationConfig';

const headerContainerSx: SxProps = {
  pt: '4px',
  pb: '20px',
  display: 'flex',
  alignItems: 'center'
};

const organizationNameSx: SxProps = {
  fontWeight: '600',
  fontStyle: 'normal',
  lineHeight: '32px',
  fontSize: '24px',
  fontFamily: 'Instrument Sans'
};

export const OrganizationHeader = ({
  organizationName
}: {
  organizationName: string;
}) => {
  const organizationConfig = useOrganizationConfig();

  return (
    <Box sx={headerContainerSx}>
      {!organizationConfig?.whiteLabelingEnabled && (
        <Box>
          <OrganizationLogo size={40} />
        </Box>
      )}
      <Box sx={organizationNameSx}>{organizationName}</Box>
    </Box>
  );
};
